/**
 * The client build's identity = the entry module script its index.html loads
 * (`/assets/index-<contenthash>.js`). Vite content-hashes it, so it changes exactly when the
 * frontend changes — unlike BUILD_HASH (sha of dist/index.js + index.html, written AFTER the build,
 * so the bundle cannot embed it, and it also moves on backend-only deploys).
 *
 * Server: read once from dist/public/index.html → /health `clientEntry`.
 * Client: the <script type="module" src="/assets/…"> it was loaded by (client/src/lib/staleBuild.ts).
 * Dev (src="/src/main.tsx") → null on both sides → the stale-tab checker is off.
 */
export function entryFromHtml(html: string): string | null {
  const tags = html.match(/<script\b[^>]*>/gi) ?? [];
  for (const tag of tags) {
    if (!/\btype\s*=\s*["']module["']/i.test(tag)) continue;
    const src = tag.match(/\bsrc\s*=\s*["']([^"']+)["']/i)?.[1];
    if (src && /^\/assets\/[^"'?#]+\.js$/.test(src)) return src;
  }
  return null;
}
